// extracted by mini-css-extract-plugin
export default {"header":"Navigation_header__yevzF","list":"Navigation_list__lu7Pj","active":"Navigation_active__lU7EE","title":"Navigation_title__9FNkg","move":"Navigation_move__sLFPt"};